import { Grid, makeStyles } from '@material-ui/core';
import { Text } from 'src/components/ui/typography';
import { white } from 'src/data/colors';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import { GhostIconButton } from 'src/components/ui/Buttons';

const useStyles = makeStyles(() => ({
  day: {
    fontSize: 12,
    color: 'red',
    backgroundColor: '#f0f0f0',
    borderRadius: '50%',
  },
  selectDate: {
    textTransform: 'uppercase',
  },
  headerContainer: {
    backgroundColor: white,
    padding: '16px 24px',
  },
  headerFirstRow: {
    paddingBottom: 16,
  },
  headerSecondRow: {
    paddingTop: 16,
    position: 'relative',
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    right: -8,
  },
  monthContainer: {
    textAlign: 'left',
  },
}));

export type HeaderProps = {
  customHeaderCount: number;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  date: Date;
};

export const Header = ({ customHeaderCount, decreaseMonth, increaseMonth, date }: HeaderProps) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.headerContainer}>
      <Grid
        container
        item
        xs={12}
        direction="column"
        alignItems="flex-start"
        className={classes.headerFirstRow}
      >
        <Text className={classes.selectDate} fontSize={12} fontFamily="mono">
          Select Date
        </Text>
        <Text fontSize={22} fontWeight={500}>
          {date.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          })}
        </Text>
      </Grid>
      <Grid
        container
        item
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        xs={12}
        className={classes.headerSecondRow}
      >
        <Grid item className={classes.monthContainer} xs>
          <Text fontSize={16} fontWeight={500}>
            {date.toLocaleString('en-US', {
              month: 'long',
              year: 'numeric',
            })}
          </Text>
        </Grid>
        <Grid item className={classes.buttonContainer} xs>
          <GhostIconButton size="small" aria-label="Previous Month" onClick={decreaseMonth}>
            <ChevronLeft />
          </GhostIconButton>
          <GhostIconButton size="small" aria-label="Next Month" onClick={increaseMonth}>
            <ChevronRight />
          </GhostIconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
